import { render, staticRenderFns } from "./CoreValueModal.vue?vue&type=template&id=75e25831"
import script from "./CoreValueModal.vue?vue&type=script&lang=js"
export * from "./CoreValueModal.vue?vue&type=script&lang=js"
import style0 from "./CoreValueModal.vue?vue&type=style&index=0&id=75e25831&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports